import { Menu } from '@mui/material'
import React from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { IEFDropdownButtonProps } from './EFButton.model'
import { EFButton } from './EFButton.component'
import styles from './EFButton.module.scss'
import classNames from 'classnames/bind'

const cx = classNames.bind(styles)
export function EFDropdownButton({
  menuProps,
  text,
  children,
  ...props
}: IEFDropdownButtonProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <EFButton
        id='dropdown-button'
        aria-controls={open ? 'dropdown-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        endIcon={<KeyboardArrowDownIcon />}
        onClick={handleClick}
        {...props}
      >
        {text}
      </EFButton>
      <Menu
        {...menuProps}
        id='dropdown-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          className: cx('dropdown-content')
        }}
        MenuListProps={{
          'aria-labelledby': 'dropdown-button',
          onMouseLeave: handleClose
        }}
      >
        {children}
      </Menu>
    </div>
  )
}
